import { render, staticRenderFns } from "./SDialogInventoriesMoveComp.vue?vue&type=template&id=2b5823a4&"
import script from "./SDialogInventoriesMoveComp.vue?vue&type=script&lang=js&"
export * from "./SDialogInventoriesMoveComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports